<div class="draw-bar-menu-for-desktop" [ngClass]="{'is-searching': isOpen && search, '-no-search': !search}">
    <shared-search-for-products-filter (onToggleOpen)="handleSearchToggle($event)" [open]="isOpen"
        class="draw-bar-menu-for-desktop__search" *ngIf="search">
    </shared-search-for-products-filter>

    <shared-sub-nav-for-expanded [relativeTarget]="relativeTarget" @enterComponent [registryId]="registryId"
        *ngIf="!isOpen" [pages]="pages" [activeId]="activeId" [scroll]="scroll"
        class="draw-bar-menu-for-desktop__subnav" (onPageClicked)="handlePageClick($event)">
    </shared-sub-nav-for-expanded>

    <shared-sub-nav-for-collapsed [relativeTarget]="relativeTarget" @enterComponent
        class="draw-bar-menu-for-desktop__subnav-collapsed" [activeId]="activeId" [scroll]="scroll"
        [registryId]="registryId" *ngIf="isOpen" [pages]="pages" (onPageClicked)="handlePageClick($event)">
    </shared-sub-nav-for-collapsed>
</div>